import { validatePhone } from '@/shared/utils'

// Validation function for Roblox Legal Verification
export const validateRobloxLegalVerification = (data: any) => {
  const errors: { [key: string]: string } = {}
  
  // Injury occurred state validation
  if (!data.injuryOccurredState) {
    errors.injuryOccurredState = 'State where injury occurred is required'
  }

  // Driver's license and screenshots validation removed - these are now in STEP 6

      // Alternative contact validation - All 3 options are valid, no validation error
      if (data.alternativeContact === 'Agreed to provide') {
        // If agreed to provide, validate the additional fields
        if (!data.alternativeContactFirstName || data.alternativeContactFirstName.trim() === '') {
          errors.alternativeContactFirstName = 'Alternative contact first name is required'
        }
        if (!data.alternativeContactLastName || data.alternativeContactLastName.trim() === '') {
          errors.alternativeContactLastName = 'Alternative contact last name is required'
        }
        if (!data.alternativeContactPhone || data.alternativeContactPhone.trim() === '') {
          errors.alternativeContactPhone = 'Alternative contact phone number is required'
        } else {
          // Validate US phone number format
          const phoneValidation = validatePhone(data.alternativeContactPhone)
          if (!phoneValidation.isValid) {
            errors.alternativeContactPhone = phoneValidation.error || 'Phone number must be a valid US phone number'
          }
        }
        if (!data.alternativeContactRelationship || data.alternativeContactRelationship.trim() === '') {
          errors.alternativeContactRelationship = 'Alternative contact relationship is required'
        }
      }

  return errors
}

/**
 * Helper function to check if a file field has a valid file
 * Can be used independently for real-time validation
 */
export const hasValidFile = (fileData: any): boolean => {
  if (!fileData) return false
  
  if (Array.isArray(fileData)) {
    return fileData.length > 0 && fileData.every(file => 
      file.url || file.name || file.isPending
    )
  }
  
  if (typeof fileData === 'object') {
    return !!(fileData.url || fileData.name || fileData.isPending)
  }
  
  return false
}

/**
 * Helper function to check file size
 * Returns true if file size is valid (under 10MB)
 */
export const hasValidFileSize = (fileData: any, maxSizeMB: number = 10): boolean => {
  const maxSize = maxSizeMB * 1024 * 1024
  
  if (!fileData) return true // No file, no size issue
  
  if (Array.isArray(fileData)) {
    return fileData.every(file => {
      const size = file.fileSize || file.size || 0
      return size <= maxSize
    })
  }
  
  if (typeof fileData === 'object') {
    const size = fileData.fileSize || fileData.size || 0
    return size <= maxSize
  }
  
  return true
}